import { useState, useRef, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Select } from 'antd';
import { FaChevronDown } from 'react-icons/fa';

import { TProductCategory, TCollection, TAssetGroup } from '@components/types';

interface MobileControlsProps {
  filterByCategory?: boolean;
  categoryId?: null | number;
  categories?: (TProductCategory | TAssetGroup)[];
  handleCategoryChange?: (id: number) => void;
  sortingOptions?: { value: string; label: string }[];
  handleSortingChange?: (option: string) => void;
  filterByCollection?: boolean;
  collectionId?: null | number;
  handleCollectionChange?: (id: number) => void;
  collections?: TCollection[];
  isScroll?: boolean;
}

export default function MobileControls({
  filterByCategory = true,
  categoryId,
  categories,
  handleCategoryChange,
  sortingOptions,
  handleSortingChange,
  filterByCollection = false,
  collectionId,
  handleCollectionChange,
  collections,
  isScroll,
}: MobileControlsProps) {
  const [width, setWidth] = useState(0);
  const carouselRef = useRef<HTMLDivElement | null>(null);

  function onSortingChange(value: string) {
    handleSortingChange(value);
  }

  useEffect(() => {
    if (carouselRef.current) {
      setWidth(
        carouselRef.current?.scrollWidth - carouselRef.current.offsetWidth
      );
    }
  }, [categories, collections]);

  return (
    <motion.div
      ref={carouselRef}
      whileTap={{ cursor: 'grabbing' }}
      className="lt-sm:py-2 w-full h-fit md:hidden relative z-30 overflow-x-hidden cursor-grab"
    >
      <motion.div
        drag="x"
        dragConstraints={{ right: 0, left: -width }}
        className="w-full flex gap-x-2.5"
      >
        {isScroll ? (
          <></>
        ) : (
          <Select
            size="middle"
            placeholder="Sort"
            options={sortingOptions}
            onChange={onSortingChange}
            defaultValue={sortingOptions[0]?.value}
            popupMatchSelectWidth={false}
            suffixIcon={
              <FaChevronDown className="w-2.5 h-2.5 text-neutral-600" />
            }
          />
        )}

        {filterByCategory &&
          categories?.map((category) => (
            <div>
              {isScroll ? (
                <button
                  type="button"
                  key={category.id}
                  onClick={() => handleCategoryChange(category.id)}
                  className={`px-1 md:h-10 h-8 w-full text-md font-semibold flex justify-center items-center rounded border border-solid  ${
                    categoryId === category.id
                      ? 'border-brand-500 text-brand-500 '
                      : 'bg-white border-neutral-200 text-neutral-700'
                  }`}
                >
                  <span className="px-2 w-max font-manrope">
                    {category.name}
                  </span>
                </button>
              ) : (
                <button
                  type="button"
                  key={category.id}
                  onClick={() => handleCategoryChange(category.id)}
                  className={`px-4 h-8 grid place-items-center rounded border border-solid border-neutral-200 ${
                    categoryId === category.id ? 'bg-neutral-800' : 'bg-white'
                  }`}
                >
                  <span
                    className={`text-sm 
                  ${
                    categoryId === category.id
                      ? 'text-neutral-100'
                      : 'text-neutral-800'
                  } 
                  font-manrope font-semibold whitespace-nowrap`}
                  >
                    {category.name}
                  </span>
                </button>
              )}
            </div>
          ))}

        {filterByCollection &&
          collections?.map((collection) => (
            <button
              type="button"
              key={collection?.id}
              onClick={() => handleCollectionChange(collection?.id)}
              className={`px-4 h-8 grid place-items-center rounded border border-solid border-neutral-200 ${
                collectionId === collection?.id ? 'bg-neutral-800' : 'bg-white'
              }`}
            >
              <span
                className={`text-sm 
                ${
                  collectionId === collection?.id
                    ? 'text-neutral-100'
                    : 'text-neutral-800'
                } 
                font-manrope font-semibold capitalize whitespace-nowrap`}
              >
                {collection?.title}
              </span>
            </button>
          ))}
      </motion.div>
    </motion.div>
  );
}
